module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido17.0ddb72f1.svg";